import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
  (theme) => ({
    dialogFooter: {
      minHeight: "80px",
      boxSizing: "border-box",
      borderTop: `1.5px solid ${theme?.palette?.secondary?.shade_100}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "16px",
      padding: theme.spacing(0, 6),
    },
    footerBtn: {
      padding: "0 16px",
    },
    secondaryBtn: {
      color: theme?.palette?.secondary?.shade_700,
    },
    upgradeContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      backgroundColor: "#FEEFD1",
      borderStyle: "solid",
      borderColor: "#F7AD1E",
      borderWidth: "2px",
      padding: "1rem",
      borderRadius: "0.375rem",
      fontWeight: 500,
      gap: "20px",
      marginTop: "10px",
      marginBottom: "10px",
    },
    upgradeText: {
      color: "#7F5400",
    },
    upgradeLink: {
      color: "#0052CC",
      textDecoration: "underline",
      cursor: "pointer",
    },
    upgradeBtnContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "16px",
    },
  }),
  { name: "CreatorTool" }
);

export default useStyles;
